import Marquee from "react-fast-marquee";

const WORDS = [
  "Honest pricing",
  "Made to be lived with",
  "Delivered across New York, by hand",
  "Small-batch textiles",
  "Furniture that outlasts trends",
];

export const EditorialMarquee = () => (
  <div data-testid="editorial-marquee" className="marquee-serif border-y border-charcoal/10 bg-powder py-6">
    <Marquee speed={28} gradient={false} pauseOnHover>
      {WORDS.map((w) => (
        <span key={w} className="mx-10 flex items-center gap-10 font-serif text-2xl font-light italic text-charcoal/80">
          {w}
          <span className="h-1.5 w-1.5 rounded-full bg-moss" />
        </span>
      ))}
    </Marquee>
  </div>
);
